import React, { Component } from 'react';
import { View, CachedImage } from 'core';
import { CDN } from 'utils';

export class Video extends Component {
  state = {};

  componentDidMount() {
    this.is_mounted = true;
    const { upload } = this.props;
    const url = CDN.getURL(upload, this._setUploadState);
    url && this.setState({ [upload.file_id]: url });
  }

  componentWillUnmount() {
    this.is_mounted = false;
  }

  _setUploadState = (url, upload) => {
    this.is_mounted && this.setState({ [upload.file_id]: url });
  };

  render() {
    const { size, upload } = this.props;
    const url = this.state[upload.file_id];
    return (
      <View style={{ justifyContent: 'center', alignItems: 'center' }}>
        {upload ? <CachedImage style={{ position: 'absolute' }} size={size} upload={upload} /> : null}
        {url ? <video style={{ ...size, position: 'absolute' }} src={url} controls /> : null}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/video.web.js